import {Component} from '@angular/core';
import {FormControl} from '@angular/forms';
import {Schedule} from '../../../models/schedule.model';
import {AdminService} from '../../../services/admin.service';
import {NgbActiveModal, NgbModal, NgbTimeStruct} from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import {ConfirmationPopupComponent} from '../../views/view-group/popups/confirmation-popup/confirmation-popup.component';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-create-schedule-popup',
  templateUrl: './create-schedule-popup.component.html',
  styleUrls: ['./create-schedule-popup.component.css'],
})
export class CreateSchedulePopupComponent {
  private schedule: Schedule;
  public successInfo = false;
  public errorInfo = false;
  public theBeginingOfTheWorkDay: NgbTimeStruct;
  public theBeginingOfTheFirstBreak: NgbTimeStruct;
  public endOfTheFirstBreak: NgbTimeStruct;
  public theBeginingOfTheLunch: NgbTimeStruct;
  public endOfTheLunch: NgbTimeStruct;
  public theBeginingOfTheSecondBreak: NgbTimeStruct;
  public endOfTheSecondBreak: NgbTimeStruct;
  public endOfTheWorkingDay: NgbTimeStruct;
  id;

  startWork = new FormControl('', (control: FormControl) => {
    const value = control.value;
    if (!value) {
      return null;
    }
    if (this.endOfTheWorkingDay && ((value.hour > this.endOfTheWorkingDay.hour)
      || (value.hour === this.endOfTheWorkingDay.hour && value.minute >= this.endOfTheWorkingDay.minute))) {
      return {tooLate: true};
    }
    return null;
  });
  // BeginingOfTheFirstBreak = new FormControl('', (control: FormControl) => {
  //   const value = control.value;
  //   if (!value) {
  //     return null;
  //   }
  //   if ((this.theBeginingOfTheWorkDay.hour > value.hour)
  //     || (this.theBeginingOfTheWorkDay.hour === value.hour && this.theBeginingOfTheWorkDay.minute >= value.minute)) {
  //     return {tooEarly: true};
  //   }
  //   return null;
  // });
  // EndFirstBreak = new FormControl('', (control: FormControl) => {
  //   const value = control.value;
  //   if (!value) {
  //     return null;
  //   }
  //   if ((this.theBeginingOfTheFirstBreak.hour > value.hour)
  //     || (this.theBeginingOfTheFirstBreak.hour === value.hour && this.theBeginingOfTheFirstBreak.minute >= value.minute)) {
  //     return {tooEarly: true};
  //   }
  //   return null;
  // });
  BeginingOfTheLunch = new FormControl('', (control: FormControl) => {
    const value = control.value;
    if (!value) {
      return null;
    }
    if (this.theBeginingOfTheWorkDay && ((this.theBeginingOfTheWorkDay.hour > value.hour)
      || (this.theBeginingOfTheWorkDay.hour === value.hour && this.theBeginingOfTheWorkDay.minute >= value.minute))) {
      return {tooEarly: true};
    }
    return null;
  });
  endLunch = new FormControl('', (control: FormControl) => {
    const value = control.value;
    if (!value) {
      return null;
    }
    if (this.theBeginingOfTheLunch && ((this.theBeginingOfTheLunch.hour > value.hour)
      || (this.theBeginingOfTheLunch.hour === value.hour && this.theBeginingOfTheLunch.minute >= value.minute))) {
      return {tooEarly: true};
    }
    if (this.endOfTheWorkingDay && ((value.hour > this.endOfTheWorkingDay.hour)
      || (value.hour === this.endOfTheWorkingDay.hour && value.minute >= this.endOfTheWorkingDay.minute))) {
      return {tooLate: true};
    }
    return null;
  });
  // BeginingOfTheSecondBreak = new FormControl('', (control: FormControl) => {
  //   const value = control.value;
  //   if (!value) {
  //     return null;
  //   }
  //   if ((this.endOfTheLunch.hour > value.hour)
  //     || (this.endOfTheLunch.hour === value.hour && this.endOfTheLunch.minute >= value.minute)) {
  //     return {tooEarly: true};
  //   }
  //   return null;
  // });
  // endSecondBreak = new FormControl('', (control: FormControl) => {
  //   const value = control.value;
  //   if (!value) {
  //     return null;
  //   }
  //   if ((this.theBeginingOfTheSecondBreak.hour > value.hour)
  //     || (this.theBeginingOfTheSecondBreak.hour === value.hour && this.theBeginingOfTheSecondBreak.minute >= value.minute)) {
  //     return {tooEarly: true};
  //   }

  //   if ((this.endOfTheWorkingDay.hour < value.hour)
  //     || (this.endOfTheWorkingDay.hour === value.hour && this.endOfTheWorkingDay.minute <= value.minute)) {
  //     return {tooLate: true};
  //   }

  //   return null;
  // });
// End DAY
  endWorkingDay = new FormControl('', (control: FormControl) => {
    const value = control.value;
    if (!value) {
      return null;
    }
    if (this.endOfTheLunch && ((this.endOfTheLunch.hour > value.hour)
      || (this.endOfTheLunch.hour === value.hour && this.endOfTheLunch.minute >= value.minute))) {
      return {tooEarly: true};
    }
    if (this.theBeginingOfTheWorkDay && ((this.theBeginingOfTheWorkDay.hour > value.hour)
      || (this.theBeginingOfTheWorkDay.hour === value.hour && this.theBeginingOfTheWorkDay.minute >= value.minute))) {
      return {tooEarly: true};
    }
    return null;
  });

  type: string;

  constructor(private adminService: AdminService,
              public activeModal: NgbActiveModal,
              private modalService: NgbModal,
              private router: Router,
              private route: ActivatedRoute) {

              this.id = this.route.snapshot.params['id'];
  }

  onTimeChange() {
    this.startWork.updateValueAndValidity();
    this.BeginingOfTheLunch.updateValueAndValidity();
    this.endLunch.updateValueAndValidity();
    this.endWorkingDay.updateValueAndValidity();
  }

  submit() {
    if(this.type === 'MODAL') {
      let sheduler = {
        theBeginingOfTheWorkDay: this.parseTime(this.theBeginingOfTheWorkDay),
        theBeginingOfTheLunch: this.parseTime(this.theBeginingOfTheLunch),
        endOfTheLunch: this.parseTime(this.endOfTheLunch),
        endOfTheWorkingDay: this.parseTime(this.endOfTheWorkingDay)
      }
      this.activeModal.close(sheduler);
    } else {
      this.successInfo = false;
      this.errorInfo = false;
      if (this.validate()) {
        const theBeginingOfTheWorkDay = this.parseTime(this.theBeginingOfTheWorkDay);
        const theBeginingOfTheLunch = this.parseTime(this.theBeginingOfTheLunch);
        const endOfTheLunch = this.parseTime(this.endOfTheLunch);
        const endOfTheWorkingDay = this.parseTime(this.endOfTheWorkingDay);
        this.schedule = new Schedule( 
          theBeginingOfTheWorkDay,
          theBeginingOfTheLunch,
          endOfTheLunch,
          endOfTheWorkingDay);
        this.sendRequest();
      } else {
        this.errorInfo = true;
        this.successInfo = false;
      }
    }
  }

  sendRequest(): void {
    const modalRef = this.modalService.open(ConfirmationPopupComponent);
    modalRef.componentInstance.massage = 'ANS';
    modalRef.componentInstance.paramSchedule = this.schedule;
    modalRef.result.then((result) => {
      if (result === 'ok') {
        this.createSchedule();
      }
    });
  }

  createSchedule() {
    this.schedule.type = "STANDARD";
    this.adminService.createSchedule(this.schedule).subscribe(
      (response: any) => {
        if (response.status === 201 || response.status === 200) {
          this.router.navigate([`/dashboard/group/edit/${this.id}`]);
          this.successInfo = true;
          this.errorInfo = false;
        }
      },
      () => {  
        this.successInfo = false;
        this.errorInfo = true;
      }
    );
  }

  // Accept all key codes except 32 (space)
  checkInput(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) { // 0-9 only
      return false;
    }
    return true;
  }

  private validate(): boolean {
    return this.startWork.valid
      && this.BeginingOfTheLunch.valid
      && this.endLunch.valid
      && this.endWorkingDay.valid;
  }

  private parseTime(time: NgbTimeStruct): string {
    const date = new Date();
    date.setHours(time.hour);
    date.setMinutes(time.minute);
    date.setSeconds(time.second);
    return moment(date).format('HH:mm');
  }
}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/admin/create-schedule-popup/create-schedule-popup.component.ts